import React, { useEffect, useState } from "react";
import Routes from "./components/routes";
import { useDispatch } from "react-redux";
import { userauthReducer } from "./components/toolkit/authReducer";
import Cookies from "universal-cookie";
import { refreshToken } from "./functions/auth";
import axios from "axios";
import { fetchMyPermissions } from "./functions/auth";
import { setPermissions, setPermissionsLoading, setPermissionsError } from "./components/toolkit/permissions/index";
import { toast } from "react-toastify";
if (typeof window !== "undefined" && !window.__axiosAuthInterceptorRegistered) {
  const cookiesForInterceptor = new Cookies();
  let sessionRedirected = false;

  axios.interceptors.response.use(
    (response) => response,

    (error) => {
      const status = error?.response?.status;
      console.log("axios error============>", error)
      const isUnauthorized = [
        "Unauthorized", 
        "jwt expired", 
        "User is blocked.",
        "User is deleted."
      ].includes(error?.response?.data?.message);

      if (isUnauthorized && !sessionRedirected) {
        sessionRedirected = true;
        try {
          cookiesForInterceptor.remove("token", { path: "/" });
          cookiesForInterceptor.remove("refreshToken", { path: "/" });
          cookiesForInterceptor.remove("userName", { path: "/" });
          cookiesForInterceptor.remove("userId", { path: "/" });
          cookiesForInterceptor.remove("name", { path: "/" });
        } catch (_) {
          console.warn("Failed clearing cookies");
        }
        if (window.location.pathname !== "/login") {
          let toastMessage = "Session expired. Redirecting to login...";
          if (error?.response?.data?.message === "jwt expired") toastMessage = "Session expired. Redirecting to login...";
          else if (error?.response?.data?.message === "User is blocked.") toastMessage = "Your account is blocked. Redirecting to login...";
          else if (error?.response?.data?.message === "Unauthorized") toastMessage = "Unauthorized access. Redirecting to login...";
          else if (error?.response?.data?.message === "User is deleted.") toastMessage = "Your account is deleted. Redirecting to login...";
          toast.error(toastMessage, {
            autoClose: 2000,
          });
          setTimeout(() => {
            window.location.replace("/login");
          }, 2000);
        }
      }

      return Promise.reject(error);
    }
  );
  window.__axiosAuthInterceptorRegistered = true;
}
function App() {

  const dispatch = useDispatch();
  const cookies = new Cookies();
  const tokenC = cookies.get("token");
  const userNameC = cookies.get("userName");
  const refreshTokenC = cookies.get("refreshToken");

  const refreshTokenFetch = async () => {
    await refreshToken(userNameC, refreshTokenC).then((res) => {
      // console.log("refreshTokenFetch=>", res);
      cookies.set("token", res.data.accessToken, {
        expires: new Date(new Date().getTime() + 60 * 60 * 1000), //ms
        maxAge: 3600,
      });
      cookies.set("refreshToken", res.data.refreshToken, {
        expires: new Date(new Date().getTime() + 60 * 60 * 1000), //ms
        maxAge: 3600,
      });
    });
  };

  useEffect(() => {
    if (tokenC && userNameC && refreshTokenC) {
      const intervalId = setTimeout(() => {
        refreshTokenFetch();
      }, 14400000);
      return () => clearTimeout(intervalId);
    }
  }, [tokenC, refreshTokenC]);

  useEffect(() => {
    if (tokenC && userNameC) {
      dispatch(
        userauthReducer({
          token: tokenC,
          username: userNameC,
          refreshToken: refreshTokenC,
        })
      );
      (async () => {
        try {
          dispatch(setPermissionsLoading());
          const res = await fetchMyPermissions();
          const list = res?.data?.permissions || [];
          dispatch(setPermissions(list));
        } catch (e) {
          dispatch(setPermissionsError(e?.response?.data?.message || String(e)));
        }
      })();
    }
  }, [tokenC, userNameC, refreshTokenC]);

  // console.log(userNameC, refreshTokenC);
  return (
    <div>
      <Routes />
    </div>
  );
}

export default App;
